import { render, staticRenderFns } from "./BlogFooter.vue?vue&type=template&id=5dfb5bc5&scoped=true&"
import script from "./BlogFooter.vue?vue&type=script&lang=js&"
export * from "./BlogFooter.vue?vue&type=script&lang=js&"
import style0 from "./BlogFooter.vue?vue&type=style&index=0&id=5dfb5bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb5bc5",
  null
  
)

export default component.exports